/*

File handles all api calls for tenants


*/
import { browserHistory } from 'react-router'
import { server } from '../engine/server'
import { modal } from '../utilities/modal'

var Group = Class.create({
  	initialize: function() {
        // #  Prepare our server object for data use
  		this.server = server;
        this.groupID = 0;

	},

	getGroup: function(context) {
		// Call server for our data
		// #  Localize this instance for use on success
		var self = this;
		// prepare our data to be sent
		var url = "buildings/groups/" + self.groupID;
		// #  Send to server object for processing
		var data = this.server.getData(url,null,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			}
			context.setState({
				groupData: response.data[0].data,
				associatedBuildings: response.data[0].associated_buildings,
				waterAmount: response.data[0].utilities.monthly_water,
				disposalAmount: response.data[0].utilities.monthly_disposal,
				sewageAmount: response.data[0].utilities.monthly_sewage
			});

		})
		.fail(function(e){
			console.log(e);
		});
	},

	/**
	*
	* Deletes a group
	*
	*/
	deleteGroup: function(e){
		// #  Localize this instance for use on success
      var self = this;
      // #  Send out success message
      modal.showDangerModalWithOK("Are you sure?","You are about to delete this group.  All data associated data will be deleted and you will not be able to recover.","Yes, Delete");
      // #  Bind okay button
      jQuery(".move-on").on('click',function() {
		// prepare our data to be sent
		var url = "buildings/groups/" + self.groupID;
		// #  Send to server object for processing
		var data = self.server.getData(url,null,false, "DELETE");
	    // #  Listen to our data
        data
        .done(function(response){
          // #  Validate response
          if(response.status == 1 || response.status == 2)
          {
          }
          else if(response.data.error != null)
          {
            modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
          }
          else
          {
			// # .Hard reset backdrop
			modal.resetBackDrop();
            // #  Send out success message
            modal.showSuccess("Group Deleted!","This group has been dropped.  All associated information with this group has been removed.");
            // #  Bind okay button
            jQuery(".move-on").on('click',function() {
				browserHistory.goBack();
            });
          }
        })
        .fail(function(e){
			console.log(e);
        });
      });
	},

	/**
	*
	* Saves group data
	*
	*/
	saveGroup: function(context, callback) {
		var self = this;
		// prepare our data to be sent
		var url = "buildings/groups/" + self.groupID;
		var params = context.state.groupData;
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false, "PUT");
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.data.error_user_authentication == 1)
			{
			}
			else if(response.data.error || (response.status == 1 || response.status == 2))
			{
			} else {
				var tenant_id = 0;
				// #  Check if new tenant
				if(self.tenantID == 0) {
					tenant_id = response.data.tenant_id;
				}
				if(callback) {
					callback(response);
				}
			}
		})
		.fail(function(e){
			modal.showInfo("Oops! Looks like you are missing data.", "warning", "top", "center");
		});
	},
	saveGroupUtility: function(groupId, monthlyUtilities, callback) {
		var self = this;
		modal.showDangerModalWithOK("Are you sure?","This will affect every tenant associated to this group.","Yes, Save Now");
		jQuery(".move-on").on('click',function() {
		  var url = "buildings/groups/" + groupId + "/utilities";
		  var data = self.server.getData(url, monthlyUtilities, false, "POST");
		  data
		  .done(function(response){
			if(response.status == 1 || response.status == 2)
			{
			}
			else if(response.data.error != null)
			{
			  modal.showInfo("Error occurred: " + response.data.error + ". Please try again", "danger", "top", "center");
			}
			else
			{
				if(callback) {
					callback(response);
				}
			}
		  })
		  .fail(function(e){
			console.log(e);
		  });
		});
	},
	/**
	*
	* set default state for when creating a new group
	*
	*/
	setDefaultState: function(context){
		context.setState({ groupData: {}});
	},

    setGroupID: function(groupID){
        this.groupID = groupID;
    }
});

export let group = new Group();


// WEBPACK FOOTER //
// app/core/controllers/Group.js